function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.444 7.044a11.517 11.517 0 004.1 4.002c1.717 1.015 3.533 1.522 5.445 1.522 1.913 0 3.728-.507 5.446-1.503 1.717-1.015 3.083-2.342 4.098-4.02.137-.255.215-.508.215-.742 0-.254-.078-.507-.215-.761a11.507 11.507 0 00-4.098-4.002C13.717.525 11.902.018 9.989.018 8.077.018 6.26.525 4.543 1.54A11.517 11.517 0 00.444 5.542a1.607 1.607 0 00-.214.76c0 .235.078.488.214.742zm5.329-4.606a4.75 4.75 0 00-.663 2.46c0 1.346.468 2.498 1.424 3.454.956.957 2.109 1.425 3.455 1.425 1.347 0 2.498-.468 3.435-1.425.957-.956 1.445-2.108 1.445-3.455 0-.878-.235-1.698-.664-2.459 1.66.86 3.045 2.147 4.138 3.865-.957 1.483-2.166 2.674-3.63 3.552a8.95 8.95 0 01-4.724 1.328c-1.698 0-3.279-.45-4.743-1.328-1.444-.878-2.655-2.069-3.63-3.552 1.113-1.718 2.498-3.006 4.157-3.865zm1.874.118c.644-.645 1.424-.977 2.342-.977.137 0 .254.06.371.157a.486.486 0 01.137.37c0 .137-.04.274-.137.371a.572.572 0 01-.371.156c-.625 0-1.17.215-1.6.664a2.166 2.166 0 00-.664 1.6.532.532 0 01-.527.527.502.502 0 01-.371-.155.502.502 0 01-.156-.372c0-.917.332-1.698.976-2.341z",
  fill: "#BEBEBE",
  fillRule: "evenodd"
});

var SvgEye = function SvgEye(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 20 13"
  }, props), _ref);
};

export default SvgEye;